import Vue from "vue";
import Toasted from "vue-toasted";
// vue-toasted gan message bang innerHTML: 3 toast global escape de chu tu BE/nguon ngoai khong chay nhu HTML.
import { toToastText } from "./toast-message-text";
const successToastedOptions = {
  containerClass: "report-success-toasted",
  position: "top-right",
  duration: 5000,
};

const errorToastedOptions = {
  containerClass: "report-error-toasted",
  position: "top-right",
  duration: 5000,
};

// TaskGov: canh bao "gui lai co the loi lai", "TASKGOV_CANH_BAO" ... khac loi (do) va thanh cong (xanh).
const warningToastedOptions = {
  containerClass: "report-warning-toasted",
  position: "top-right",
  duration: 7000,
};

Vue.use(Toasted);

Vue.toasted.register(
  "showErrorMessage",
  (payload) => {
    return toToastText(payload.message);
  },
  errorToastedOptions
);

Vue.toasted.register(
  "showSuccessMessage",
  (payload) => {
    return toToastText(payload.message);
  },
  successToastedOptions
);

Vue.toasted.register(
  "showWarningMessage",
  (payload) => {
    return toToastText(payload.message);
  },
  warningToastedOptions
);
